import React, { useState, useEffect } from 'react';
import { Slider } from 'antd';
import './index.scss';
import variables from '../../../variable.scss';
import { useTranslation } from 'react-i18next';

const handleStyles = ['voting-red', 'voting-red-light', 'voting-orange', 'voting-grey',
  'voting-light-light-green', 'voting-light-green', 'voting-green'].map((color, index) => ({
    backgroundColor: variables[color], transform: 'none', left: `${index * 100 / 7}%`
  }));

export default function Voting({ onChange, onChangeComplete, onSave, scope = 4 }) {
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState(scope);
  // Feed gestures are controlled by the parent, which can reject a guest
  // gesture at the trial limit. Editors commit their local value on release.
  const value = onChange ? scope : inputValue;

  const onChangeCompleteVoting = (newValue) => {
    onChangeComplete?.(newValue);
    onSave?.(newValue);
  };

  const onChangeVoting = (newValue) => {
    setInputValue(newValue)
    onChange?.(newValue);
  };

  useEffect(() => {
    setInputValue(scope);
  }, [scope]);

  return (
    <div className="voting-wrapper" data-no-swipe>
      <div className="voting-segments" aria-hidden="true">
        {handleStyles.map((style, index) => <span key={index}
          data-selected={index + 1 === Number(value)}
          style={{ backgroundColor: style.backgroundColor }} />)}
      </div>
      <Slider
        className='voting'
        min={1}
        max={7}
        onChange={onChangeVoting}
        onChangeComplete={onChangeCompleteVoting}
        tooltip={{ open: false }}
        value={typeof value === 'number' ? value : 4}
        handleStyle = {handleStyles[value-1]}
        ariaLabelForHandle={t('post.your_opinion')}
      />
      </div>
  );
}
